import { Search } from '@frontend/components/icons/outline'
import { useSearchStore } from '@frontend/libs/stores/useSearchStore'
import { Button } from '@nextui-org/react'

function SearchButton() {
  const { openModal } = useSearchStore((state) => state)
  return (
    <Button onPress={openModal}>
      <Search className="block h-10 w-10 !max-w-none" />
    </Button>
  )
}

export default SearchButton
